// import { useGetReferralsMetaQuery } from "app/redux/referralsService";
// import { Icon } from "helpers/icons";
import moment from "moment";
import { Icon } from "../../helpers/icons";

export const getReferralsPrototype = () => {

    return {
        "reason": "",
        "patient_insurance_id": "",
        "pid": "",
        "referring_by_id": "",
        "referring_by": "",
        "referring_to_id": "",
        "referring_to": "",
        "referral_type": "outgoing",
        "outgoing_referral_type": "specialty",
        "from_date": "",
        "to_date": "",
        "visits_allowed": "",
        "validity": "",
        "visits_used": "",
        "amount": "",
        "referral_no": "",
        "provider_auth_no": "",
        "practice_id": "",
        "rendering_care": "",
        "practice_location_id": "",
        "is_active": false,
        "group_id": "",
        "fee": "",
        "created_by": "",
        "updated_by": "",
        "created": "",
        "updated": "",
        "completed_date": "",
        "location_id": "",
        "location_name": "",
        "assigned_to": [],
        "status": "",
        "authorization_required": 0,
        "urgency": "normal",
        "associated_cpt_codes": [],
        "associated_icd_codes": [],
        "comments": "",
        "clinical_notes": "",
        "is_internal": false,
        "service_request_group1": "",
        "service_request_group2": "",
        "other_status": "",
        "referral_provider_speciality": "",
        "device_type": "",
        "is_patient_instruction_given": "",
        "is_summary_of_care_sent": "",
        "reconcile_data": {
            "allergy_data": [

            ],
            "problem_data": [

            ],
            "medication_data": [

            ]
        },
        "task_id": "",
        "referral_status": "new",
        "show_encounter_dignosis":false,
        "referral_print_uuid": "",
        "shared_to_patient_portal": false,
        "create_task": false,
        "referring_by_name": "",
        "referring_to_name": "",
        "referring_to_fax": "",
        "referring_to_phone": "",
        "assigned_to_name": "",
        "patient_insurance_name": "",
        "patient_name": "",
        "phone_home": "",
        "mrn": "",
        "full_name": "",
        "status_title": "",
        "urgency_title": "",
        "referral_status_title": "",
        "is_referral_sent": false,
        "referral_sent_uuid": "",
        "assigned_to_users": [],
        "group_info": {
            "group_info_detail": [],
            "other_users": []
        },
        "referral_provider_speciality_title": "",
        "referred_to_date": "",
        "files": [

        ],
        "receipts": [

        ],
        "referringFax": "",
        "referringPhone": "",
        "did_no_reach_thrice": false,
        "created_by_name": "",
        "updated_by_name": "",
        "created_at": "",
        "updated_at": "",
        "encounter_id": false
    }
}

export const getReferralField = (fieldKey, section = 'referral_information') => {
    return ReferralFormSections[section].fields.find((f) => f.key == fieldKey);
}

export const patchDataObjects = (formData, MetaData) => {
    //patient.referrals.addReferralsInfo.selectedUsers = item.group_info.group_info_detail.concat(item.group_info.other_users);
    // postData?.practice_location_id
    let data = { ...formData };
    data.assigned_to_users=formData?.group_info?.group_info_detail?.concat(formData.group_info.other_users)
    data.reviews = data?.reviews;
    data.to_date = data.to_date ? new Date(data.to_date) : '';
    data.from_date = data.from_date ? new Date(data.from_date) : '';
    data.referring_to = data.referring_to_name && data.referring_to_name != "" ? { name: data.referring_to_name, id: data.referring_to_id } : null;
    data.referring_by = data.referring_by_name ? { name: data.referring_by_name, id: data.referring_by_id } : null;
    data.speciality = data.referral_provider_speciality_title ? { title: data.referral_provider_speciality_title, id: data.referral_provider_speciality } : null;
    data.rendering_provider = data.rendering_title ? { name: data.rendering_title, id: data.rendering_care } : null;
    data.patient_insurance = data.patient_insurance_name ? { plan_name: data.patient_insurance_name, id: data.patient_insurance_id } : null;
    data.surgery= data?.service_request_group2?.includes("surgery");
    data.diagnostic_testing= data?.service_request_group2?.includes("diagnostic_testing");
    data.show_encounter_dignosis=true;
    if (MetaData?.task_group && MetaData?.task_group.length > 0) {
        var foundIndex = _.findIndex(MetaData?.locations, function (group) {
            return group.id == data?.practice_location_id;
        });
        if (foundIndex > -1) {

            data.practice_location_id = MetaData?.locations[foundIndex];
        }
    }
    if (data.reason) {
        data.reason = data.reason.reason ? data.reason.reason : { reason: data.reason, reason_speciality:data.reason};
    }
    if (data.is_internal && data.is_internal != 0) {

    }
    return data;
}

export const preparePostData = postData => {
    if (postData.speciality && postData.speciality.id) {
        postData.referral_provider_speciality = postData.speciality.id;
        postData.referral_provider_speciality_title = postData.speciality.title;
        
    }
    if (postData.create_radiology || postData.create_radiology=="1"){
        postData.create_radiology=1 
    }
    if (postData.referring_to && postData.referring_to.id) {
        postData.referring_to_id = postData.referring_to.id;
        postData.referring_to_name = postData.referring_to.name;
    }
    if (postData.rendering_provider && postData.rendering_provider.id) {
        postData.rendering_title = postData.rendering_provider.name;
        postData.rendering_care = postData.rendering_provider.id;
    }
    if (postData.patient_insurance && postData.patient_insurance.id) {
        postData.patient_insurance_name = postData.patient_insurance.plan_name;
        postData.patient_insurance_id = postData.patient_insurance.id;
    }
    delete postData.review;
}

export const ReferralFormSections = {
    referral_information: {
        title: 'Referral Information',
        key: 'referral_information',
        fields: [
            {
                title: '', key: 'outgoing_referral_type', type: 'radio', value: 'specialty',
                radioOptions: [
                    { title: 'Specialty', key: 'specialityCheck', value: 'specialty' },
                    { title: 'DME', key: 'dmeCheck', value: 'dme' },
                ],
                width: 3
            },
            { title: 'Internal Referral', key: 'is_internal', type: 'checkbox', selected: false, width: 3 },
            {
                title: 'Authorization Required', key: 'authorization_required', type: 'radio', value: 'Authorization Required',
                radioOptions: [
                    { title: 'No', key: 'authorization_required', value: "0" },
                    { title: 'Yes', key: 'authorization_required', value: "1" },
                ],
                width: 3
            },
            {
                title: 'Reason', key: 'reason', type: 'creatable_search', metaKey: 'referral_templates', showLabel: 'reason_speciality', width: 4,
                rules: { required: { value: true, message: 'Reason is required.' } },
                onCreateOption: val => {
                    return { reason: val }
                }
            },
            { title: 'Specialty', key: 'speciality', type: 'specialty_search', width: 4, rules: { required: { value: true, message: 'Specialty is required.' } } },
            { title: 'Device Type', key: 'device_type', type: 'select', metaKey: 'referral_device_type', width: 4, hidden: true },
            { title: 'Referred To', key: 'referring_to', type: 'provider_search', showLabel: 'name', optionData: [], width: '4' },
            { title: 'Referral No.', key: 'referral_no', width: '4', disabled: true },
            { title: 'Referring to Location', key: 'location_name', type: 'text', width: 4 },
            { title: 'Phone', key: 'referring_to_phone', width: 4, disabled: true },
            { title: 'Fax', key: 'referring_to_fax', width: 4, disabled: true },
            {
                title: 'Assigned To', key: 'assigned_to_users', type: 'local_search', showLabel: 'name', multiple: true, metaKey: 'user_groups', opKey: 'id', width: 6,
                rules: { required: { value: true } },
                getOptionLabel: item => {
                    if (item.type == 'group') {
                        return (
                            <>
                                <Icon type="user-group" size="4" /><span className="ml-2">{item.title}</span>
                            </>
                        )
                    }
                    return item.name;
                }
            },
            { title: 'Create Task', key: 'create_task', type: 'toggle', width: '2', hidden: false },
            {
                title: 'Referral Status', showLabel:"title", key: 'referral_status', type: 'select',getValueLabel:"label", metaKey: 'OverAllReferenceTypes', titleCustomStyle:" w-fit bg-bgGreen px-2 py-0.5 mt-2  text-green-c-150 ",
                width: 4,
                radioOptions: [
                    { title: 'New', value: 'new' },
                    { title: 'Pending', value: 'pending' },
                    { title: 'Scheduled', value: 'scheduled' },
                    { title: 'Completed', value: 'completed' },
                    { title: 'Not Abled to Contact', value: 'not_able_to_contact' },
                    { title: 'Cancelled', value: 'cancelled' },
                ]
            },
            {
                title: 'Urgency', key: 'urgency', type: 'radio',customClass:"flex gap-x-5", titleCustomStyle:"flex w-fit bg-bgGreen px-2 py-0.5 mt-1.5  text-green-c-150 ",
                width: 8,
                radioOptions: [
                    // { title: 'Low', value: 'low' },
                    // { title: 'Normal', value: 'normal' },
                    // { title: 'High', value: 'high' },
                    // { title: 'Urgent', value: 'urgent' },
                ]
            },

            { title: 'Referred By', key: 'referring_by', type: 'local_search', metaKey: 'provider_list', showLabel: 'name', opKey: 'referring_by_id' },

            { title: 'Plan', key: 'patient_insurance', type: 'local_search', metaKey: 'patient_insurances', showLabel: 'plan_name' },
            {
                title: 'PAN / Auth. No', key: 'provider_auth_no', rules: {
                    maxLength: { value: 15, message: "Maximum 15 character  allowed" },
                }
            },
            { title: 'Date From', key: 'from_date', type: 'date', minDate: moment().toDate() },
            { title: 'Date To', key: 'to_date', type: 'date', minDate: moment().toDate() },
            {
                title: 'Validity', key: 'validity', disabled: true, type: "number",
                rules: {
                    min: {
                        value: 0,
                        message: "Minimum 0 number allowed"
                    },
                }
            },
            { title: 'Allowed Visits', key: 'visits_allowed' },
            {
                title: 'Fee($)', key: 'fee', rules: {
                    maxLength: { value: 6, message: "Maximum 6 digits allowed" },
                }
            },

            { title: 'Practice Location', key: 'practice_location_id', type: 'local_search', metaKey: 'locations', showLabel: "name", opTitle: 'name', opKey: 'id', width: 4 },
            { title: 'Supervising Provider', key: 'rendering_provider', type: 'local_search', metaKey: 'provider_list', showLabel: 'name' },
            { title: 'Save Template', key: 'template', type: 'toggle', width: '2' },
        ]
    },
    services_requested: {
        title: 'Services Requested',
        fields: [
            {
                key: 'service_request_group1', type: 'radio',
                width: '6',
                radioOptions: [
                    { title: 'Consult', value: 'consult' },
                    { title: 'Evaluate & treat', value: 'evaluate_treat' },
                    { title: 'Follow-up & treat', value: 'follow_up_treat' },
                    { title: 'Assume Care', value: 'assume_care' },
                ]
            },
            {
                key: 'service_request_group2', type: 'checkbox_group',
                width: '6',
                checkboxOptions: [
                    { title: 'Surgery', key: 'surgery' },
                    { title: 'Diagnostic Testing', key: 'diagnostic_testing' },
                ]
            },
            { title: 'Services', key: 'associated_cpt', type: 'cpt_search', width: '4' },
        ]
    },
    diagnosis: {
        title: 'Diagnosis',
        fields: [
            { title: 'Diagnosis', key: 'associated_icd', type: 'icd_search', width: '4' },
            { title: 'Show Only Encounter Diagnosis', key: 'show_encounter_dignosis', type: 'checkbox', width: 3 },

        ]
    },
    notes: {
        title: 'Notes',
        fields: [
            {
                title: 'Clinical Notes', key: 'clinical_notes', nusa_concept_name:"Clinical Notes",
                nusa_enabled:true,type: 'textarea', width: 6, enableSmartPhrase: true, position: " right-1 top-1 "
            },
            {
                title: 'Internal Notes', key: 'comments', type: 'textarea', width: 6, enableSmartPhrase: true, position: " right-1 top-1 ",nusa_concept_name:"Internal Notes",
                nusa_enabled:true,
            },
        ]
    }
}

export const ReferralsFields = [
    { title: 'titlTxt', key: 'keyTxt' },
]

export const externalProviderPrototype = {
    speciality: '',
    organization_name: '',
    location_name: '',
    first_name: '',
    last_name: '',
    city: '',
    state: 'GA',
    zip: '',
    data: ''
}

export const externalProviderFields = [
    { title: 'Organization Name', key: 'organization_name' },
    { title: 'First Name', key: 'first_name' },
    { title: 'Last Name', key: 'last_name' },
    { title: 'Nearby Location', key: 'location_name', type: 'location_search' },
    { title: 'City', key: 'city', width: 2 },
    { title: 'State', key: 'state', width: 2, type: 'state' },
    { title: 'Zip', key: 'zip', width: 2 },
    { title: 'Specialty', key: 'speciality', type: 'specialty_search' },
]

export const ReferralAttachmentFields = [
    { title: 'Title', name: 'title', width: 'w-1/2', rules: { required: { value: true, message: 'Title is required.' } }, },
    { title: 'Date', name: 'date', type: 'date', width: 'w-1/2', rules: { required: { value: true, message: 'Date is required.' } }, },
    { title: 'Description', name: 'description', type: "textarea" },
]

export const referralAttachmentData = {
    attachments: "",
    title: "",
    date: "",
    description: "",
    created_by_name: "",
    created_by: "",
    files: [],
    type: "",
};

export const getReferralFollowupPrototype = () => {
    return {
        "user_type": "patient",
        "user_id": "",
        "referral_type": "outgoing",
        "contacted_by": "",
        "contact_notes": "",
        "practice_id": "",
        "contact_status": "",
        "appointment_id": "",
        "referral_id": "",
        "contact_status_title": "",
        "appointment_booked_with": ""
    }
}

export const ReferralFollowupFields = [
    {
        title: 'Status', name: 'contact_status', type: 'select', metaKey: 'referral_status', width: 'col-span-4',
        rules: { required: { value: true, message: 'Status is required.' } }
    },
    { title: 'Appointment Date', name: 'start_time', type: 'date', isTime: true, hidden: true, width: 'col-span-4', rules: { required: { value: true, message: 'Date is required.' } }, },
    { title: 'Appointment booked with', name: 'appointment_booked_with', isTime: true, hidden: true, width: 'col-span-4' },
    { title: 'Follow up Notes', name: 'contact_notes', type: "textarea",width:"col-span-12" },
]